import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private orderSubject = new Subject<any>();


  newOrder$ = this.orderSubject.asObservable();

  showNewOrderNotification(order: any): void {
    this.orderSubject.next(order);
  }
}
